<template>
  <div>
    <div class="question-loading-area" v-if="complete">
      <div class="inner-question-loading">
        <p class="loading-logo-pos"><img src="/common/img/logo_loading.png" alt="nanacara"></p>
        <p>{{ $t('it_is_currently_being_processed') }}</p>
        <p>{{ $t('please_wait') }}</p>
      </div>
    </div>
    <div v-else>
      <NotFound/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import NotFound from "@/js/components/NotFound"
export default {
  components: {
    NotFound
  },
  data() {
      return {
          complete: false,
          pre_url: '',
          user_id: '',
          survey_data_local: {},
      }
  },
  async mounted() {
    this.checkCompleteSurvey()
  },
  computed: {
    ...mapState({
      errorMsg: state => state.survey.errorMsg
    }),
  },
  methods: {
      async checkCompleteSurvey () {
        this.user_id = this.$store.state.auth.doctorInfo.id ? this.$store.state.auth.doctorInfo.id : null
        this.survey_data_local = localStorage.getItem('vuex') ? JSON.parse(localStorage.getItem('vuex')).survey : null
        this.pre_url = document.referrer
        let domain_pre_url = this.pre_url.split('/')[2]
        if (this.survey_data_local && this.survey_data_local.banner_redirect_url.includes(domain_pre_url)) {
          await this.handleCompleteSurvey()
        }
        else {
          this.complete = false
          this.pre_url = ''
        }
      },
      async handleCompleteSurvey() {
        this.complete = true
        let params = {
          survey_id: this.survey_data_local.survey_id,
        }
        await this.$store.dispatch('survey/completeSurvey', params)
        if(this.errorMsg) {
          console.log("error: ", this.errorMsg)
        }
        else {
          window.open(this.survey_data_local.survey_thank_page_url, '_self')
        }
      }
    }
};
</script>
<style scoped>
  .question-loading-area {
      width: 400px;
      margin: 0 auto;
      padding-top: 100px;
      box-sizing: border-box;
  }
  .question-loading-area .inner-question-loading {
      position: relative;
      width: 400px;
      background: #ffffff;
      border: 1px solid #ff8ea1;
      border-radius: 10px;
      box-sizing: border-box;
      padding: 60px 20px 20px 20px;
      font-size: 1.2rem;
      line-height: 1.8rem;
      text-align: center;
  }
  .question-loading-area .inner-question-loading .loading-logo-pos {
      position: absolute;
      top: -45px;
      left: 50%;
      transform: translateX(-50%);
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
  }
</style>